var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c(
        "div",
        { staticClass: "q-display-1 q-mb-md text-secondary" },
        [
          _c("q-icon", {
            staticClass: "q-mb-sm",
            attrs: { name: "far fa-file-upload" }
          }),
          _vm._v(" " + _vm._s(_vm.$t("code_apple")) + "\n    ")
        ],
        1
      ),
      _c("div", { staticClass: "row gutter-xs q-mb-sm" }, [
        _c(
          "div",
          { staticClass: "col-4" },
          [
            _c("q-input", {
              attrs: { "float-label": "Total de codigos", disable: true },
              model: {
                value: _vm.total_code,
                callback: function($$v) {
                  _vm.total_code = $$v
                },
                expression: "total_code"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-4" },
          [
            _c("q-input", {
              attrs: {
                "float-label": "Total de codigos usados",
                disable: true
              },
              model: {
                value: _vm.used,
                callback: function($$v) {
                  _vm.used = $$v
                },
                expression: "used"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-4" },
          [
            _c("q-input", {
              attrs: {
                "float-label": "Total de codigos não usados",
                disable: true
              },
              model: {
                value: _vm.not_used,
                callback: function($$v) {
                  _vm.not_used = $$v
                },
                expression: "not_used"
              }
            })
          ],
          1
        )
      ]),
      _c("q-table", {
        attrs: {
          data: _vm.codes,
          columns: _vm.columns,
          pagination: _vm.server_pagination,
          loading: _vm.loading,
          filter: _vm.filter,
          "row-key": "name",
          "no-data-label": _vm.$t("no_data_avaliable"),
          "no-results-label": _vm.$t("no_results_found"),
          "loading-label": _vm.$t("loading_data"),
          "rows-per-page-label": _vm.$t("items_per_page"),
          "rows-per-page-options": [5, 10, 50, 100],
          "binary-state-sort": ""
        },
        on: {
          "update:pagination": function($event) {
            _vm.server_pagination = $event
          },
          request: _vm.request
        },
        scopedSlots: _vm._u([
          {
            key: "top-right",
            fn: function(props) {
              return [
                _c("q-search", {
                  attrs: {
                    icon: "far fa-search",
                    placeholder: _vm.$t("search"),
                    debounce: 500
                  },
                  model: {
                    value: _vm.filter,
                    callback: function($$v) {
                      _vm.filter = $$v
                    },
                    expression: "filter"
                  }
                })
              ]
            }
          },
          {
            key: "top",
            fn: function(props) {
              return [
                _c("div", { staticClass: "col" }),
                _c("q-btn", {
                  staticClass: "q-mr-md",
                  attrs: {
                    color: "secondary",
                    icon: "far fa-sync",
                    label: _vm.$t("update_codes")
                  },
                  on: {
                    click: function($event) {
                      return _vm.request({ pagination: _vm.server_pagination })
                    }
                  }
                }),
                _c("q-btn", {
                  attrs: {
                    color: "secondary",
                    icon: "far fa-upload",
                    label: _vm.$t("import")
                  },
                  on: {
                    click: function($event) {
                      _vm.show_modal = true
                    }
                  }
                })
              ]
            }
          },
          {
            key: "header",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                _vm._l(props.cols, function(col) {
                  return _c(
                    "q-th",
                    { key: col.name, attrs: { props: props } },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t(col.label)) +
                          "\n            "
                      )
                    ]
                  )
                }),
                1
              )
            }
          },
          {
            key: "body",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                [
                  _c(
                    "q-td",
                    { key: "id", attrs: { "auto-width": "", props: props } },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(props.row.id) +
                          "\n            "
                      )
                    ]
                  ),
                  _c("q-td", { key: "created_date", attrs: { props: props } }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.fDate(props.row.created_date)) +
                        "\n            "
                    )
                  ]),
                  _c("q-td", { key: "code", attrs: { props: props } }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(props.row.code) +
                        "\n            "
                    )
                  ]),
                  _c(
                    "q-td",
                    { key: "user_full_name", attrs: { props: props } },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(props.row.user_full_name) +
                          "\n            "
                      )
                    ]
                  ),
                  _c("q-td", { key: "user_email", attrs: { props: props } }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(props.row.user_email) +
                        "\n            "
                    )
                  ])
                ],
                1
              )
            }
          }
        ])
      }),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: "80vw",
              maxWidth: "100vw",
              minHeight: "90vh"
            }
          },
          on: {
            hide: function($event) {
              _vm.show_modal = false
            }
          },
          model: {
            value: _vm.show_modal,
            callback: function($$v) {
              _vm.show_modal = $$v
            },
            expression: "show_modal"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.show_modal = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("import")) +
                        "\n                "
                    )
                  ])
                ],
                1
              ),
              _c("div", { staticClass: "layout-padding" }, [
                _c("div", { staticClass: "row gutter-sm q-mt-sm" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-12" },
                      [
                        _c("p", { staticClass: "caption" }, [
                          _vm._v(_vm._s(_vm.$t("file")))
                        ]),
                        _c("uploader", {
                          attrs: {
                            content_type: "",
                            multiple: false,
                            error: _vm.$v.file_url.$error
                          },
                          on: { fileUploaded: _vm.fileUploaded }
                        }),
                        _vm.file_url
                          ? _c(
                              "p",
                              { staticClass: "q-mt-md file-url" },
                              [
                                _c("q-icon", {
                                  attrs: {
                                    name: "fal fa-check",
                                    color: "positive"
                                  }
                                }),
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: _vm.file_url,
                                      target: "_blank"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$truncateLink(_vm.file_url))
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ]),
                _c(
                  "div",
                  { staticClass: "row gutter-sm justify-end q-mt-lg" },
                  [
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-3" },
                      [
                        _c("q-btn", {
                          staticClass: "full-width",
                          attrs: {
                            color: "tertiary",
                            label: _vm.$t("back"),
                            icon: "far fa-chevron-left"
                          },
                          on: {
                            click: function($event) {
                              _vm.show_modal = false
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-3" },
                      [
                        _c("q-btn", {
                          staticClass: "full-width",
                          attrs: {
                            color: "secondary",
                            label: _vm.$t("save"),
                            icon: "far fa-save"
                          },
                          on: {
                            click: function($event) {
                              return _vm.saveData()
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }